var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNwdLogoStripes = function SvgNwdLogoStripes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75.32,
    height: 109.741,
    viewBox: "0 0 75.32 109.741",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16613.961 -542.745)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16588.1 542.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.445,213.5h10.382L95.819,323.245l-10.449-.066Z",
    transform: "translate(-85.37 -213.504)",
    fill: "#8860d0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16613.961 542.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.409,213.5h10.382L68.783,323.245l-10.449-.066Z",
    transform: "translate(-58.334 -213.504)",
    fill: "#8860d0"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNwdLogoStripes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nwd-logo-stripes.19e18377.svg";
export { ForwardRef as ReactComponent };